// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PFilePptOutlinedSvg from "@fishx/icons-svg/es/asn/PFilePptOutlined";
import FishxIcon from '../components/FishxIcon';

var PFilePptOutlined = function PFilePptOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PFilePptOutlinedSvg
  }));
};

PFilePptOutlined.displayName = 'PFilePptOutlined';
export default React.forwardRef(PFilePptOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PFilePptOutlined.js
// module id = 3393
// module chunks = 0